import { createBlockFenceExtension } from '@/components/block-primitives/block-fence-extension';
import { agentBlockRegistry, instructionBlockRegistry } from './agent-block-registry';
import { LegacyFenceNotice, RawFenceNotice } from './fence-notices';
import InstructionValidationBoundary from './instruction-validation-boundary';

// The runtime sends legacy fences to the model as raw JSON, so each one offers to become the versioned block.
export const AgentBlockExtension = createBlockFenceExtension({
  nodeName: 'agentBlock',
  fencePrefix: 'agent:',
  dataPrefix: 'data-agent-block',
  registry: agentBlockRegistry,
  prettyPrintConfig: true,
  upgrade: { nodeName: 'instructionBlock', registry: instructionBlockRegistry, Notice: LegacyFenceNotice },
});

// A separate node preserves legacy fences when a document contains both formats.
export const InstructionBlockExtension = createBlockFenceExtension({
  nodeName: 'instructionBlock',
  fencePrefix: 'agent-v1:',
  dataPrefix: 'data-instruction-block',
  registry: instructionBlockRegistry,
  prettyPrintConfig: true,
  requireTopLevelFence: true,
  Wrapper: InstructionValidationBoundary,
  RawFenceNotice,
});
